import * as React from "react"
import { Route, RouteProps } from "react-router-dom"
import { AuthLevel, UserContext } from "./UserContext"

interface ProtectedRouteProps {
    authLevel?: AuthLevel,
    authMethodFilter?: string[]
}

export const ProtectedRoute: React.FC<RouteProps & ProtectedRouteProps> = ({children, ...rest}) => {
    const {isLoggedIn} = React.useContext(UserContext)
    const [needLogin, setNeedLogin] = React.useState(false)

    const defaultAuthLevel = rest.authLevel ?? AuthLevel.HIGH
    const authMethodFilter = rest.authMethodFilter
    console.log("IS IN PROTECTED ROUTE!")
    

    return (
        <Route
            {...rest}
            component={() => {
                if (!needLogin) {
                    return children
                } else {
                    return null as any
                }
            }}
        />
    )
}